export const PROMPT_LOCALSTORAGE_KEY = "$PROMPT_DATA" as const;
export const AI_COOKIE_KEY = "AI_TOKEN" as const;
export const ALLOWED_MEDIA_EXTENSIONS = ["flac", "m4a", "mp3", "mp4", "mpeg", "mpga", "oga", "ogg", "wav", "webm"];
export const MAX_AUDIO_DURATION_MS = 300000;
export const MAX_AUDIO_HISTORY_ITEMS = 3;
